"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_MULTI_ENTITY_INVOICES = exports.GET_TRANSACTIONS = exports.GET_CLIENT_TUITION_PROVIDERS = exports.GET_CLIENT_ORGANIZATIONS_BY_ACCOUNT_IDS = exports.UPDATE_RECOVERY_QUESTION = exports.GET_MEMBERSHIPS = exports.UPDATE_ACCOUNT_PERSON_ACCOUNT_JOB_TITLE = exports.UPDATE_ACCOUNT_PERSON_ACCOUNT = exports.DEALLOCATE_SEATS = exports.ALLOCATE_SEATS = exports.SEND_PRINT_INVOICES = exports.PROVISION_SEAT = exports.GET_SERVICE_CONTRACTS = exports.MAKE_INVOICE_PAYMENT = exports.GET_INVOICE_PAYMENT_CONFIRMATION_DETAILS = exports.GET_INVOICE = exports.GET_INVOICE_FILE = exports.GET_INVOICES = void 0;
exports.GET_INVOICES = `
  query getInvoices($legalEntity: String, $filter: GetInvoicesFilter) {
    getInvoices(legalEntity: $legalEntity, filter: $filter)
  }
`;
exports.GET_INVOICE_FILE = `
    query getInvoiceFile($invoiceId: String) {
      getInvoiceFile(invoiceId: $invoiceId)
    }
`;
exports.GET_INVOICE = `
    query getInvoice($invoiceId: String) {
      getInvoice(invoiceId: $invoiceId){   
        id
        invoiceDate
        dueDate
        amount
        balance
        invoiceNumber
        status
        accountId
        orderNumber
        installmentTerm
        paymentTerm
      }
    }
`;
exports.GET_INVOICE_PAYMENT_CONFIRMATION_DETAILS = `
    query getInvoicePaymentConfirmationDetails($invoiceId: String) {
      getInvoicePaymentConfirmationDetails(invoiceId: $invoiceId){
        id
        invoiceDate
        dueDate
        amount
        balance
        invoiceNumber
        status
        accountId
        paymentDate
      }
    }
`;
exports.MAKE_INVOICE_PAYMENT = `
  mutation payInvoice($paymentMethodId: String!, $isB2B: Boolean!, $saveCreditCard: Boolean!, $amount: Float!, $balance: Float!, $accountId: String!, $invoiceId: String!, $invoiceNumber: String!, $orderNumber: String, $installmentTerm: String, $paymentTerm: String, $rootOrganizationId: String, $invoiceEntity: String, $paymentMethod: String){
    payInvoice(paymentMethodId: $paymentMethodId, isB2B: $isB2B, saveCreditCard: $saveCreditCard, amount: $amount, balance: $balance, accountId: $accountId, invoiceId: $invoiceId, invoiceNumber: $invoiceNumber, orderNumber: $orderNumber, installmentTerm: $installmentTerm, paymentTerm: $paymentTerm, rootOrganizationId: $rootOrganizationId, invoiceEntity: $invoiceEntity,  paymentMethod: $paymentMethod){
      id
      invoiceId
      number
      status
      accountId
      amount
      currency
      effectiveDate
      success
      message
      reasons {
        code
        message
      }
    }
  }
`;
exports.GET_SERVICE_CONTRACTS = `
  {
    getServiceContracts {
      id
      orderNumber
		  productName
      startDatetime
		  endDatetime
		  totalQuantity
      allocatedQuantity
      cancelledQuantity
      deprovisionAllowed
      seatProductId
      contractLineItems {
        contactId
        contactEmail
        contactName
        contractLineItemId
        contractLineItemAccessEndDate
      }
      isExtendable
    }
  }
`;
exports.PROVISION_SEAT = `
    query provisionSeat($inviteToken: String, $type: Int) {
      provisionSeat(inviteToken: $inviteToken, type: $type)
    }
`;
exports.SEND_PRINT_INVOICES = `
  query sendPrintInvoices($InvoiceNumberFrom: String, $InvoiceNumberTo: String, $CreationDateFrom: String, $CreationDateTo: String, $AICPAUID: String, $LegalEntity: String, $AccountNameFrom: String, $AccountNameTo: String, $ProductRatePlanFrom: String, $ProductRatePlanTo: String, $InvCompany: String, $DaysOverdueFrom: String, $DaysOverdueTo: String, $BalanceFrom: String!, $BalanceTo: String, $EmailInvoices: Boolean!, $EmailAddress: String, $SendToPrint: Boolean!, $TransactionType: String, $FileName: String, $TransactionNumberFrom: String, $TransactionNumberTo: String, $Company: String, $EmailTransactions: Boolean) {
    sendPrintInvoices(InvoiceNumberFrom: $InvoiceNumberFrom, InvoiceNumberTo: $InvoiceNumberTo, CreationDateFrom: $CreationDateFrom, CreationDateTo: $CreationDateTo, AICPAUID: $AICPAUID, LegalEntity: $LegalEntity, AccountNameFrom: $AccountNameFrom, AccountNameTo: $AccountNameTo, ProductRatePlanFrom: $ProductRatePlanFrom, ProductRatePlanTo: $ProductRatePlanTo, InvCompany: $InvCompany, DaysOverdueFrom: $DaysOverdueFrom, DaysOverdueTo: $DaysOverdueTo, BalanceFrom: $BalanceFrom, BalanceTo: $BalanceTo, EmailInvoices: $EmailInvoices, EmailAddress: $EmailAddress, SendToPrint: $SendToPrint, TransactionType: $TransactionType, FileName: $FileName, TransactionNumberFrom: $TransactionNumberFrom, TransactionNumberTo: $TransactionNumberTo, Company: $Company, EmailTransactions: $EmailTransactions) {
      success
      fileName
    }
  }
`;
exports.ALLOCATE_SEATS = `
  mutation allocateSeats($serviceContractsIds: [String!]!, $endUserEmails: [String!]!){
      allocateSeats(serviceContractsIds: $serviceContractsIds, endUserEmails: $endUserEmails)
    }
`;
exports.DEALLOCATE_SEATS = `
  mutation deAllocateSeats($lineItemIds: [String!], $emails: [String!]){
      deAllocateSeats(lineItemIds: $lineItemIds, emails: $emails)
    }
`;
exports.UPDATE_ACCOUNT_PERSON_ACCOUNT = `
    mutation updateAccountPersonAccount($id: String, $role: String) {
      updateAccountPersonAccount(id: $id, role: $role){
        id
        success
        errors
      }
    }
`;
exports.UPDATE_ACCOUNT_PERSON_ACCOUNT_JOB_TITLE = `
    mutation updateAccountPersonAccountJobTitle($id: String, $role: String, $jobTitle: String) {
      updateAccountPersonAccountJobTitle(id: $id, role: $role, jobTitle: $jobTitle){
        id
        success
        errors
      }
    }
`;
exports.GET_MEMBERSHIPS = `
{
  getMemberships
}
`;
exports.UPDATE_RECOVERY_QUESTION = `
    mutation sendRecoveryQuestionEmail($recoveryQuestion: RecoveryQuestion) {
      sendRecoveryQuestionEmail(recoveryQuestion: $recoveryQuestion)
    }
`;
exports.GET_CLIENT_ORGANIZATIONS_BY_ACCOUNT_IDS = `
{
  clientOrganizations {
    id
    name
    creditHoldStatus
    hasAICPAUid
    isFirmBillingEnabled
    parentId
    currentParentId
    billingAddress {
      addressLine1
      city
      state
      zipCode
      country
    }
    shippingAddress {
      addressLine1
      city
      state
      zipCode
      country
    }
    numCPA
    isPCAOBOrganization
    PCAOBNumOfIssuers
    phone
    type
  }
}
`;
exports.GET_CLIENT_TUITION_PROVIDERS = `
{
  clientTuitionProviders {
    id
    name
    creditHoldStatus
    hasAICPAUid
    isFirmBillingEnabled
    parentId
    currentParentId
    billingAddress {
      addressLine1
      city
      state
      zipCode
      country
    }
    shippingAddress {
      addressLine1
      city
      state
      zipCode
      country
    }
    numCPA
    isPCAOBOrganization
    PCAOBNumOfIssuers
    phone
    type
  }
}
`;
exports.GET_TRANSACTIONS = `
  query getTransactions( $dropdownLegalEntity: String, $dateFromValue: String, $dateToValue: String) {
    getTransactions(legalEntity: $dropdownLegalEntity, startDate: $dateFromValue, endDate: $dateToValue)
  }
`;
exports.GET_MULTI_ENTITY_INVOICES = `
    query getMultiEntityInvoices($legalEntity: String, $zuoraIds: [String]) {
      getMultiEntityInvoices(legalEntity: $legalEntity, zuoraIds: $zuoraIds)
    }
`;
//# sourceMappingURL=client-admin-queries.js.map